import highchartsNoDataToDisplay from "highcharts/modules/no-data-to-display";

import highchartsTheme from "layout/highcharts.theme";

export const initializeHighcharts = Highcharts => {
  Highcharts.setOptions(highchartsTheme);
  highchartsNoDataToDisplay(Highcharts);
};
